import React, { useState } from 'react'
import _ from 'lodash'

import styles from './FormField.module.css'

function FileInput({ placeholder, disabled, onSelect, accept }) {
  const [fileName, setFileName] = useState('')

  const handleFileSelect = event => {
    const fileInput = event.target
    if (onSelect) onSelect(fileInput.files[0])
    setTimeout(() => {
      setFileName(_.last(fileInput.value.split('\\')) || '')
    })
  }

  return (
    <div className={styles.fileInput}>
      <label className="input input-file">
        <div className="button">
          <input
            type="file"
            accept={accept}
            onChange={handleFileSelect}
            disabled={disabled}
          />
          BROWSE
        </div>
        <input
          type="text"
          placeholder={placeholder || 'Choose a file...'}
          readOnly
          value={fileName}
          onChange={() => {}}
          disabled={disabled}
        />
      </label>
    </div>
  )
}

export default FileInput
